import React from 'react';
import CookieConsent from 'react-cookie-consent';

/* Colours are token references (react-cookie-consent takes inline styles, so
 * the CSS custom properties are used directly). The banner is a floating
 * overlay: opaque overlay ground + primary text + a decorative top edge; Accept
 * is the primary action (label on the AA brand fill); the link is normal-size
 * brand text on that ground. Decline (only rendered if `enableDeclineButton`
 * is ever set) is the secondary fill. Each pair is in the design-system gate. */
const BANNER_STYLE: React.CSSProperties = {
  background: "var(--ips-surface-overlay)",
  color: "var(--ips-text)",
  borderTop: "1px solid var(--ips-border)",
  boxShadow: "var(--ips-shadow-lg)",
  // The support-chat launcher (48px round, fixed 24px from the right, z 2001)
  // sits over the banner's bottom-right corner: keep Accept clear of it.
  paddingRight: "88px",
};
const ACCEPT_STYLE: React.CSSProperties = {
  background: "var(--ips-primary-strong)",
  color: "var(--ips-primary-fg)",
  fontSize: "13px",
};
const DECLINE_STYLE: React.CSSProperties = {
  background: "var(--ips-secondary)",
  color: "var(--ips-secondary-fg)",
  fontSize: "13px",
};
const LINK_STYLE: React.CSSProperties = { color: "var(--ips-primary-strong)" };

const CookieConsentPopup: React.FC = () => {
  const handleAcceptCookies = () => {
    // console.log("Cookies accepted");
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'ad_storage': 'granted',
        'analytics_storage': 'granted'
      });
    }
  };

  const handleDeclineCookies = () => {
    // console.log("Cookies declined");
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'ad_storage': 'denied',
        'analytics_storage': 'denied'
      });
    }
  };

  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept"
      declineButtonText="Decline"
      cookieName="cookiesConsent"
      style={BANNER_STYLE}
      buttonStyle={ACCEPT_STYLE}
      declineButtonStyle={DECLINE_STYLE}
      onAccept={handleAcceptCookies}
      onDecline={handleDeclineCookies}
    >
      This website uses cookies to enhance the user experience.{" "}
      <a href="/privacy-policy" style={LINK_STYLE}>More info</a>
    </CookieConsent>
  );
};

export default CookieConsentPopup;
